<template>
  <div>
    <div class="search">
      <div class="title">企业概况</div>
      <div class="form-container">
        <el-form>
          <el-row>
            <el-col :span="6">
              <el-form-item label="企业名称" label-width="80px">
                <el-input
                  placeholder="请输入企业名称"
                  v-model="enterpriseName"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属区域" label-width="110px">
                <el-select placeholder="请选择供所属区域" v-model="cityCode">
                  <el-option label="全部" value="" />
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.short_name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button type="primary" class="submit" @click="initQuery"
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="statics">
      <div class="header"><span>数据统计</span></div>
      <div class="body">
        <div class="statics-item">
          <div class="title">
            <div class="text">
              <div class="main-text">流通企业数量统计</div>
              <div class="sub-text">流通企业数量</div>
            </div>
            <div class="number">
              <div class="count">{{ circulateEnterpriseTotalNum }}</div>
              <div class="sub-text">流通企业数量</div>
            </div>
          </div>
          <Echarts :echartsOption="echartsOption0" echartsHeight="450px" />
        </div>
        <div class="statics-item">
          <div class="title title2">
            <div class="text">
              <div class="main-text">零售企业数量统计</div>
              <div class="sub-text">零售企业数量</div>
            </div>
            <div class="number">
              <div class="count">{{ retailEnterpriseTotalNum }}</div>
              <div class="sub-text">零售企业数量</div>
            </div>
          </div>
          <Echarts :echartsOption="echartsOption2" echartsHeight="450px" />
        </div>
        <div class="border"></div>
      </div>
    </div>
    <div class="enterprise-list">
      <div class="header"><span>企业列表</span></div>
      <el-table :data="dataList" class="enterprise-table">
        <el-table-column
          label="统一社会信用编码"
          prop="org_code"
          width="150px"
        />
        <el-table-column label="企业名称" prop="comp_name" width="200px" />
        <el-table-column label="企业类型" prop="comp_type_text" />
        <el-table-column label="所属区域" prop="city_name" />
        <el-table-column label="联系方式" prop="phone" />
        <el-table-column label="企业邮箱" prop="email" />
        <el-table-column label="企业地址" prop="ent_address" width="190px" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="btn" @click="getDetail(scope.row)"
              >企业详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        @current-change="loadEnterpriseList"
        :page-size="5"
      />
    </div>
    <enterprise-detail
      :detailVisible="detailVisible"
      :closeDialog="closeDialog"
      :showDrugList="false"
      :enterpriseId="enterpriseId"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Echarts from 'components/echarts/echarts';
import EnterpriseDetail from 'components/enterprise-detail/enterprise-detail';

export default {
  data() {
    return {
      enterpriseName: '',
      cityCode: '',
      circulateEnterpriseTotalNum: 0,
      echartsOption0: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          minInterval: 1,
          type: 'value',
          boundaryGap: [0, 0.01],
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          }
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          },
          data: []
        },
        series: [
          {
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            },
            data: []
          }
        ]
      },
      retailEnterpriseTotalNum: 0,
      echartsOption2: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          minInterval: 1,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          }
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          },
          data: []
        },
        series: [
          {
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#FFB439' },
                { offset: 0, color: '#FFD739' }
              ])
            },
            data: []
          }
        ]
      },
      total: 0,
      currentPage: 1,
      dataList: [],
      enterpriseId: '',
      detailVisible: false
    };
  },
  computed: {
    ...mapState(['cityList'])
  },
  mounted() {
    this.initQuery();
  },
  methods: {
    initQuery() {
      this.currentPage = 1;
      this.loadEnterpriseTotalNum(this.$common.entType.circulate);
      this.loadEnterpriseTotalNum(this.$common.entType.retail);

      this.loadEnterpriseEchartsData(this.$common.entType.circulate);
      this.loadEnterpriseEchartsData(this.$common.entType.retail);

      this.loadEnterpriseList(1);
    },
    // 零售企业与流通企业总数量统计
    loadEnterpriseTotalNum(entType) {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: { pageNum: 1, pageSize: 1000 },
            params: {
              handlerName: 'query_ent_num',
              entType: entType,
              organName: this.enterpriseName,
              cityCode: this.cityCode
            }
          })
        }
      }).then(res => {
        const num = res.list[0].num;
        if (entType === this.$common.entType.circulate) {
          this.circulateEnterpriseTotalNum = num;
        } else if (entType === this.$common.entType.retail) {
          this.retailEnterpriseTotalNum = num;
        }
      });
    },
    // 零售企业与流通企业echarts图
    loadEnterpriseEchartsData(entType) {
      this.$request({
        url: 'open/circulation/checkEntAreaStatics',
        data: {
          json: JSON.stringify({
            params: {
              entType: entType,
              organName: this.enterpriseName,
              cityCode: this.cityCode
            }
          })
        }
      }).then(res => {
        const yData = [];
        const seriesData = [];
        res.list.reverse().forEach(item => {
          yData.push(item.cityName);
          seriesData.push(item.num);
        });
        this[`echartsOption${entType}`].yAxis.data = yData;
        this[`echartsOption${entType}`].series[0].data = seriesData;
      });
    },
    // 企业列表
    loadEnterpriseList(currentPage) {
      this.currentPage = currentPage;
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: { pageNum: this.currentPage, pageSize: 5 },
            params: {
              handlerName: 'query_bpent_list',
              organName: this.enterpriseName,
              cityCode: this.cityCode
            }
          })
        }
      }).then(res => {
        this.dataList = res
          ? res.list.map(item => ({
              ...item,
              comp_type_text: this.$common.entTypeMap[item.comp_type]
            }))
          : [];
        this.total = res ? res.total : 0;
      });
    },
    getDetail(row) {
      this.enterpriseId = row.id;
      this.detailVisible = true;
    },
    closeDialog() {
      this.detailVisible = false;
    }
  },
  components: {
    Echarts,
    EnterpriseDetail
  }
};
</script>

<style lang="stylus" scoped>
.search
  .title
    background url('~assets/images/bg-circle.png')
    background-size cover
    height 74px
    line-height 60px
    padding-left 21px
    font-size 18px
    border-radius 8px 8px 0 0
  .form-container
    position relative
    background #fff
    border-radius 8px
    transform translate(0, -16px)
    padding 20px
    .submit
      margin-left 30px
.statics, .enterprise-list
  border-radius 8px
  margin 20px 0
  padding 0 20px
  background #fff
  color #000
  .header
    line-height 60px
    border-bottom 1px solid #CEDBEF
    span
      border-left 4px solid #386CE2
      padding-left 8px
      color #242424
  .body
    display flex
    position relative
    .statics-item
      width 50%
      .title
        border-bottom 1px solid #CEDBEF
        padding 13px 40px 13px 0
        overflow hidden
        .text
          float left
        .main-text
          font-size 14px
          color #000000
          margin-bottom 5px
        .sub-text
          font-size 12px
          color #666666
        .number
          float right
          .count
            color #386CE2
            font-size 20px
            text-align right
        &.title2
          padding-left 39px
    .border
      position absolute
      width 1px
      background #CEDBEF
      left 50%
      top 0
      bottom 0
.enterprise-list
  overflow hidden
  .enterprise-table
    margin-top 20px
    font-size 12px
    >>>.el-table__body-wrapper
        .cell
          line-height 20px
          padding 10px 10px
    .btn
      font-size 12px
  .pagination
    float right
    padding 30px 0
</style>
